import { Modal } from 'antd';
const { confirm } = Modal;

export default (options) => {
  confirm(options);
};
